export default {
    assessment_score_1: "",
    assessment_score_2: "",
    assessment_score_3: "",
};
